import { useUsersState } from "@contexts/users.context";

const useIsLoggedIn = () => {
  const { userInfo } = useUsersState();
  return !!userInfo && !!userInfo.is_once_modified;
};
export default useIsLoggedIn;
